import { Flex } from '@awais4123/fillify-design-library';
import { TieringDetailsTableContentCell } from 'pages/SettingsPage/modals/ShiftDistributionRulesTieringModal/ShiftDistributionRulesTieringModal.styled';
import styled from 'styled-components';

export const ModalHeaderSection = styled(Flex)`
  border-top: 1px solid ${({ theme }) => theme.colors.Grey4};
  flex-direction: column;
  width: 100%;
  gap: 20px;
  padding: 40px 32px 12px 32px;
`;

export const Subheading = styled.div`
  ${({ theme }) => theme.fonts.PoppinsText};
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  font-size: 28px;
  font-weight: 600;
  line-height: 34px;
`;

export const PositionTitle = styled.div`
  ${({ theme }) => theme.fonts.PoppinsTextBold};
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
`;

export const Text = styled.div`
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
`;

export const BoldText = styled.div`
  ${({ theme }) => theme.fonts.PoppinsTextBold};
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  font-size: 16px;
  font-style: normal;
  line-height: 24px;
  padding: 10px 32px;
`;

export const PositionDetailsTableContentCell = styled(TieringDetailsTableContentCell)`
  padding: 0px 52px;
  border-top: 1px solid ${({ theme }) => theme.colors.Grey4};
`;
